export const transactionStatus = {
  open: 'open',
  processing: 'processing',
  expired: 'expired',
  failed: 'failed',
  success: 'success',
  completed: 'completed',
}

export const statuses = [
  {
    key: transactionStatus.open,
    label: transactionStatus.open,
    color: 'primary',
  },
  {
    key: transactionStatus.processing,
    label: transactionStatus.processing,
    color: 'warning',
  },
  {
    key: transactionStatus.expired,
    label: transactionStatus.expired,
    color: 'disable',
  },
  {
    key: transactionStatus.failed,
    label: transactionStatus.failed,
    color: 'error',
  },
  {
    key: transactionStatus.success,
    label: transactionStatus.success,
    color: 'green-light',
  },
  {
    key: transactionStatus.completed,
    label: transactionStatus.completed,
    color: 'disable',
  },
]
